(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Kayna", [], factory);
	else if(typeof exports === 'object')
		exports["Kayna"] = factory();
	else
		root["Kayna"] = factory();
})(self, () => {
return 